/**
 * LEGACY IN-PAGE ANCHORS — old dingwellfh.ca id -> this site's section id.
 *
 * A `#hash` is never sent to the server, so a redirect cannot fix one:
 * `/about_us/#services` redirects to `/about-us/#services`, which matches nothing
 * because the new section id is `our-services` (ids are derived by slugify(title),
 * see packages/funeral-ui/src/utils/slugify.js).
 *
 * Rewriting the hash client-side is the only option that keeps the new nav/CTAs —
 * which already point at the new ids — working. Renaming the sections to match the
 * old ids was rejected: it would break every internal link the new site already
 * has, in order to fix inbound links from the site being replaced.
 *
 * Consumed by gatsby-browser.js `onRouteUpdate`. It lives in its own module, NOT
 * in gatsby-node.js, so the browser bundle never imports Node-only build code.
 */
export const LEGACY_HASH_ALIASES = {
  // Home page bands.
  immediate_need: "immediate-need",
  meet_the_director: "meet-the-director",
  plan_ahead: "plan-ahead",
  // The old nav's "RESOURCES" pointed at the on-page "A time for joy" band.
  resources: "a-time-for-joy",
  contact: "contact-us-here",
  // The old "Located in Souris" band's id was literally `about_us`.
  about_us: "located-in-souris",
  // About Us page.
  services: "our-services",
  gallery: "dingwell-virtual-tour",
  // Resources page. The old site's own "Grief Healing" link (#grief_healing)
  // matched nothing there either; it points at the "Give Us a Call" block, which
  // is that page's de-facto grief content.
  flowers: "flowershops",
  grief_healing: "give-us-a-call",
  // `who_we_are` needs no alias — slugify("Who We Are") is already `who-we-are`.
}

export default LEGACY_HASH_ALIASES
